import { authApiCall } from '../../auth';

// /api/v1/blogs/

// export const getBlogs = () => {
//   return authApiCall({
//     url: '/blogs/',
//     method: 'get',
//   });
// };

// export const getBlog = id => {
//   return authApiCall({
//     url: `/blogs/${id}/`,
//     method: 'get',
//   });
// };

// export const createBlog = data => {
//   return authApiCall({
//     url: '/blogs/',
//     method: 'post',
//     data,
//   });
// };

// export const updateBlog = (id, data) => {
//   return authApiCall({
//     url: `/blogs/${id}/`,
//     method: 'patch',
//     data,
//   });
// };

// export const deleteBlog = id => {
//   return authApiCall({
//     url: `/blogs/${id}/`,
//     method: 'delete',
//   });
// };


// /api/v1/blogs/blogs/

export const getBlogs = params => {
  const query = params ? `?${new URLSearchParams(params).toString()}` : '';

  return authApiCall({
    url: `/blogs/blogs/${query}`,
    method: 'get',
  });
};

export const getBlog = id =>
  authApiCall({
    url: `/blogs/blogs/${id}/`,
    method: 'get',
  });

export const getBlogBySlug = slug =>
  authApiCall({
    url: `/blogs/blogs/by-slug/${slug}/`,
    method: 'get',
  });

export const createBlog = data =>
  authApiCall({
    url: '/blogs/blogs/',
    method: 'post',
    data,
  });

export const updateBlog = (id, data) =>
  authApiCall({
    url: `/blogs/blogs/${id}/`,
    method: 'patch',
    data,
  });

export const deleteBlog = id =>
  authApiCall({
    url: `/blogs/blogs/${id}/`,
    method: 'delete',
  });


export const getBlogAuthors = () =>
  authApiCall({
    url: '/blogs/authors/',
    method: 'get',
  });

export const getBlogAuthor = id =>
  authApiCall({
    url: `/blogs/authors/${id}/`,
    method: 'get',
  });

export const createBlogAuthor = data =>
  authApiCall({
    url: '/blogs/authors/',
    method: 'post',
    data,
  });

export const updateBlogAuthor = (id, data) =>
  authApiCall({
    url: `/blogs/authors/${id}/`,
    method: 'patch',
    data,
  });

export const deleteBlogAuthor = id =>
  authApiCall({
    url: `/blogs/authors/${id}/`,
    method: 'delete',
  });

export const getBlogBusinesses = () =>
    authApiCall({
      url: '/users/all-business-list/',
      method: 'get',
    });